module.exports = __webpack_public_path__ + "media/images/cbjj/academy_registration_informations/rules_draw-a250cc40e4301a7f2b9c753d8865c2b7.svg";